(function() {
  var __sections__ = {};
  (function() {
    for(var i = 0, s = document.getElementById('sections-script').getAttribute('data-sections').split(','); i < s.length; i++)
      __sections__[s[i]] = true;
    })();
    (function() {
  if (!__sections__["basson-forge-home"] && !Shopify.designMode) return;
  try {
    
(function(){
  function initHomeReviews(root){
    if(!root || root.dataset.carouselReady==='true') return;
    var viewport=root.querySelector('[data-review-viewport]');
    var track=root.querySelector('[data-review-track]');
    var prev=root.querySelector('[data-review-prev]');
    var next=root.querySelector('[data-review-next]');
    if(!viewport||!track||!prev||!next) return;
    var cards=Array.prototype.slice.call(track.querySelectorAll('[data-review-card]'));
    if(!cards.length) return;
    root.dataset.carouselReady='true';
    var index=0;
    var timer=null;
    var autoplay=root.dataset.autoplay==='true';
    var delay=parseInt(root.dataset.delay,10)||7000;
    var reduce=window.matchMedia&&window.matchMedia('(prefers-reduced-motion: reduce)').matches;
    function visibleCount(){return 1;}
    function maxIndex(){return Math.max(0,cards.length-visibleCount());}
    function cardWidth(){return cards[0].getBoundingClientRect().width;}
    function goTo(i,smooth){
      var max=maxIndex();
      if(i>max)i=0;
      if(i<0)i=max;
      index=i;
      viewport.scrollTo({left:cardWidth()*index,behavior:smooth&&!reduce?'smooth':'auto'});
    }
    function sync(){
      var w=cardWidth();if(!w)return;
      index=Math.min(maxIndex(),Math.max(0,Math.round(viewport.scrollLeft/w)));
    }
    function stop(){if(timer){window.clearInterval(timer);timer=null;}}
    function start(){stop();if(autoplay&&!reduce&&cards.length>visibleCount()){timer=window.setInterval(function(){goTo(index+1,true);},delay);}}
    prev.addEventListener('click',function(){stop();goTo(index-1,true);start();});
    next.addEventListener('click',function(){stop();goTo(index+1,true);start();});
    viewport.addEventListener('scroll',function(){window.clearTimeout(viewport._reviewScrollTimer);viewport._reviewScrollTimer=window.setTimeout(sync,120);},{passive:true});
    viewport.addEventListener('keydown',function(e){if(e.key==='ArrowLeft'){e.preventDefault();prev.click();}if(e.key==='ArrowRight'){e.preventDefault();next.click();}});
    root.addEventListener('mouseenter',stop);
    root.addEventListener('mouseleave',start);
    root.addEventListener('focusin',stop);
    root.addEventListener('focusout',start);
    root.addEventListener('touchstart',stop,{passive:true});
    root.addEventListener('touchend',start,{passive:true});
    window.addEventListener('resize',function(){goTo(Math.min(index,maxIndex()),false);start();});
    start();
  }
  function initAll(){document.querySelectorAll('[data-home-reviews]').forEach(initHomeReviews);}
  if(document.readyState==='loading'){document.addEventListener('DOMContentLoaded',initAll);}else{initAll();}
  document.addEventListener('shopify:section:load',initAll);
})();

  } catch(e) { console.error(e); }
})();

(function() {
  if (!__sections__["basson-newsletter-popup"]) return;
  try {
    
  if (!customElements.get('basson-newsletter-popup')) {
    customElements.define('basson-newsletter-popup', class extends HTMLElement {
      connectedCallback() {
        this.dialog = this.querySelector('dialog');
        if (!this.dialog || this.ready) return;
        this.ready = true;
        this.key = 'basson-newsletter-popup-session-v2';
        this.pendingKey = this.key + '-pending';
        this.preview = this.dataset.preview === 'true';
        this.onSelect = () => this.show();
        this.addEventListener('shopify:section:select', this.onSelect);
        this.querySelectorAll('[data-close]').forEach(button => button.addEventListener('click', () => this.dismiss()));
        this.dialog.addEventListener('cancel', () => this.remember());
        this.dialog.addEventListener('click', event => {
          if (event.target !== this.dialog) return;
          const rect = this.dialog.getBoundingClientRect();
          if (event.clientX < rect.left || event.clientX > rect.right || event.clientY < rect.top || event.clientY > rect.bottom) this.dismiss();
        });
        const form = this.querySelector('form');
        form?.querySelector('button[type="submit"]')?.addEventListener('click', () => {
          if (form.checkValidity()) this.dialog.close();
        }, { capture: true });
        form?.addEventListener('submit', () => {
          try { sessionStorage.setItem(this.pendingKey, String(Date.now())); } catch {}
          this.dialog.close();
        });
        let pending = 0;
        let shown = false;
        try {
          pending = Number(sessionStorage.getItem(this.pendingKey));
          shown = sessionStorage.getItem(this.key) === 'shown';
        } catch {}
        const response = this.querySelector('[data-response]');
        if (response && pending && Date.now() - pending < 1800000) {
          try { sessionStorage.removeItem(this.pendingKey); } catch {}
          if (response.dataset.response === 'success') this.remember();
          this.timer = setTimeout(() => this.show(), 0);
          return;
        }
        if (!this.preview && (this.dataset.subscriber === 'true' || shown)) return;
        this.timer = setTimeout(() => this.show(), Number(this.dataset.delay) * 1000);
      }
      show() {
        if (!this.isConnected || this.dialog.open || typeof this.dialog.showModal !== 'function') return;
        if (document.querySelector('dialog[open]') || document.hidden) {
          this.timer = setTimeout(() => this.show(), 1000);
          return;
        }
        this.dialog.showModal();
        this.remember();
        const target = this.querySelector('input[type="email"], .bnp-success');
        target?.focus({ preventScroll: true });
      }
      remember() {
        if (this.preview) return;
        try { sessionStorage.setItem(this.key, 'shown'); } catch {}
      }
      dismiss() {
        this.remember();
        this.dialog.close();
      }
      disconnectedCallback() { clearTimeout(this.timer); }
    });
  }

  } catch(e) { console.error(e); }
})();
})();
